/* Nor-Tech dealer page (Angle of Attack Marine)
   Loaded by several sections with defer; guarded so it only runs once.
   Each section root carries data-nt="strip|models|inventory|quote" and is
   initialised independently, including when re-rendered in the theme editor. */
(function () {
  if (window.__ntLoaded) return;
  window.__ntLoaded = true;

  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  /* ---------- helpers shared across sections ---------- */
  function quoteForm() { return $('[data-quote-form]'); }
  function setSelect(sel, value) {
    if (!sel || !value) return;
    var match = Array.prototype.some.call(sel.options, function (o) { return (o.value || o.text) === value; });
    if (!match) sel.insertAdjacentHTML('beforeend', '<option>' + esc(value) + '</option>');
    sel.value = value;
  }

  /* ---------- pre-fill: built-in form or an app form (Globo etc.) ----------
     Built-in form: fields marked data-q-model / data-q-interest.
     App form: finds the field whose label contains the keyword set in the
     NT: Quote form section (data-model-label / data-interest-label). */
  var norm = function (v) { return String(v || '').toLowerCase().replace(/nor-?tech/g, '').replace(/[^a-z0-9]+/g, ' ').trim(); };
  function fire(el) {
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function labelFor(ctrl) {
    if (ctrl.labels && ctrl.labels.length) return ctrl.labels[0].textContent;
    var el = ctrl;
    for (var i = 0; i < 5 && el; i++) {
      el = el.parentElement; if (!el) break;
      var l = el.querySelector('label, legend, .label, [class*="label"]');
      if (l && !l.contains(ctrl)) return l.textContent;
    }
    return '';
  }
  function pickOption(options, value) {
    var n = norm(value), hit = null;
    options.forEach(function (o) { if (!hit && norm(o.value) === n) hit = o; });
    options.forEach(function (o) { if (!hit && norm(o.textContent || o.value) === n) hit = o; });
    options.forEach(function (o) { var t = norm(o.textContent || o.value); if (!hit && t && (t.indexOf(n) > -1 || n.indexOf(t) > -1)) hit = o; });
    return hit;
  }
  function prefill(kind, value) {
    if (!value) return;
    var builtIn = $(kind === 'model' ? '[data-q-model]' : '[data-q-interest]');
    if (builtIn) { setSelect(builtIn, value); return; }
    var app = $('.q-app'); if (!app) return;
    var key = (app.dataset[kind + 'Label'] || '').toLowerCase().trim(); if (!key) return;
    var selects = $$('select', app).filter(function (s) { return labelFor(s).toLowerCase().indexOf(key) > -1; });
    if (selects.length) {
      var opt = pickOption($$('option', selects[0]), value);
      if (opt) { selects[0].value = opt.value; fire(selects[0]); }
      return;
    }
    /* radio buttons */
    var radios = $$('input[type="radio"]', app).filter(function (r) { return labelFor(r).toLowerCase().indexOf(key) > -1 || (r.closest('fieldset, [class*="form-control"], [class*="field"]') || { textContent: '' }).textContent.toLowerCase().indexOf(key) > -1; });
    var target = pickOption(radios.map(function (r) { return { value: r.value, textContent: (r.labels && r.labels[0] ? r.labels[0].textContent : r.value), el: r }; }), value);
    if (target) { target.el.checked = true; target.el.click(); fire(target.el); return; }
    /* plain text field */
    var inputs = $$('input[type="text"], input:not([type])', app).filter(function (i) { return labelFor(i).toLowerCase().indexOf(key) > -1; });
    if (inputs.length) { inputs[0].value = value; fire(inputs[0]); }
  }

  /* Image fallback: any photo that fails to load shows a "Photos coming soon" tile */
  document.addEventListener('error', function (e) {
    var t = e.target;
    if (!t || t.tagName !== 'IMG' || !t.closest('.nt')) return;
    var box = t.closest('figure,.model-media,.modal-media,.inv-media,.split-media,.step-img > div,.step-img,.hero-media,.quote-bg');
    t.style.visibility = 'hidden';
    if (box) box.classList.add('noimg');
  }, true);

  /* ---------- photo strip ---------- */
  function initStrip(root) {
    var strip = $('[data-strip-track]', root);
    if (!strip || strip.__nt) return; strip.__nt = true;
    $$('[data-strip]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var fig = strip.querySelector('figure'); if (!fig) return;
        var w = fig.getBoundingClientRect().width + 14;
        strip.scrollBy({ left: b.dataset.strip === 'next' ? w : -w, behavior: 'smooth' });
      });
    });
    var down = false, x0 = 0, s0 = 0;
    strip.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; x0 = e.clientX; s0 = strip.scrollLeft;
      strip.style.scrollSnapType = 'none'; strip.style.cursor = 'grabbing';
    });
    window.addEventListener('pointermove', function (e) { if (down) strip.scrollLeft = s0 - (e.clientX - x0); });
    window.addEventListener('pointerup', function () {
      if (!down) return; down = false; strip.style.scrollSnapType = ''; strip.style.cursor = '';
    });
    strip.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  /* ---------- models slider + popup ---------- */
  function initModels(root) {
    var slider = $('[data-slider-track]', root);
    if (!slider || slider.__nt) return; slider.__nt = true;
    var picker = $('.model-picker', root);
    var modal = $('[data-modal]', root);
    var models = [];
    try { models = JSON.parse($('[data-models-json]', root).textContent); } catch (err) { models = []; }

    var visibleCards = function () { return $$('.model-card', slider).filter(function (c) { return !c.classList.contains('is-hidden'); }); };
    var step = function () { var c = visibleCards()[0]; return c ? c.getBoundingClientRect().width + 20 : 320; };
    var prev = $('[data-slider="prev"]', root), next = $('[data-slider="next"]', root);

    [prev, next].forEach(function (b) {
      if (!b) return;
      b.addEventListener('click', function () {
        slider.scrollBy({ left: b.dataset.slider === 'next' ? step() : -step(), behavior: 'smooth' });
      });
    });

    if (picker) picker.addEventListener('click', function (e) {
      var b = e.target.closest('[data-jump]'); if (!b) return;
      var card = $('.model-card[data-id="' + b.dataset.jump + '"]', slider);
      if (card) slider.scrollTo({ left: card.offsetLeft - slider.offsetLeft, behavior: 'smooth' });
    });

    function syncUI() {
      var max = slider.scrollWidth - slider.clientWidth - 2;
      if (prev) prev.disabled = slider.scrollLeft <= 2;
      if (next) next.disabled = slider.scrollLeft >= max;
      var cards = visibleCards(); if (!cards.length || !picker) return;
      var best = cards[0], bestD = Infinity;
      cards.forEach(function (c) {
        var d = Math.abs((c.offsetLeft - slider.offsetLeft) - slider.scrollLeft);
        if (d < bestD) { bestD = d; best = c; }
      });
      var id = (slider.scrollLeft >= max ? cards[cards.length - 1] : best).dataset.id;
      $$('button', picker).forEach(function (b) {
        var on = b.dataset.jump === id;
        b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on);
      });
    }
    var raf;
    slider.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(syncUI); });
    window.addEventListener('resize', syncUI);

    $$('[data-filter]', root).forEach(function (chip) {
      chip.addEventListener('click', function () {
        var f = chip.dataset.filter;
        $$('[data-filter]', root).forEach(function (c) { c.setAttribute('aria-pressed', c === chip); });
        $$('.model-card', slider).forEach(function (c) { c.classList.toggle('is-hidden', f !== 'all' && c.dataset.type !== f); });
        if (picker) $$('button', picker).forEach(function (b) { b.classList.toggle('is-hidden', f !== 'all' && b.dataset.type !== f); });
        slider.scrollTo({ left: 0 }); syncUI();
      });
    });

    /* popup */
    if (!modal) { syncUI(); return; }
    /* move the popup to <body> so theme stacking contexts can't trap it; keep .nt scope */
    var host = document.createElement('div');
    host.className = 'nt nt-modal-host';
    host.style.background = 'none';
    host.appendChild(modal);
    document.body.appendChild(host);
    root.__ntModalHost = host;

    var lastFocus;
    var img = $('[data-m-img]', modal), media = $('[data-m-media]', modal);
    var thumbs = $('[data-m-thumbs]', modal), count = $('[data-m-count]', modal);

    function openModal(id) {
      var m = models.filter(function (x) { return x.id === id; })[0]; if (!m) return;
      lastFocus = document.activeElement;
      media.classList.remove('noimg');
      img.style.visibility = '';
      if (m.img) { img.src = m.img; } else { img.removeAttribute('src'); media.classList.add('noimg'); }
      img.alt = 'Nor-Tech ' + m.name;
      var g = m.gallery || [];
      media.classList.toggle('has-gallery', g.length > 1);
      thumbs.hidden = count.hidden = g.length < 2;
      thumbs.innerHTML = g.length > 1 ? g.map(function (p, i) {
        return '<button type="button" data-g="' + i + '" class="' + (i === 0 ? 'is-active' : '') + '" aria-label="Photo ' + (i + 1) + ' of ' + g.length + '"><img src="' + esc(p.th) + '" alt=""></button>';
      }).join('') : '';
      if (g.length > 1) { img.src = g[0].src; count.textContent = '1 / ' + g.length; }
      thumbs.onclick = function (e) {
        var b = e.target.closest('[data-g]'); if (!b) return;
        var i = +b.dataset.g; img.style.visibility = ''; media.classList.remove('noimg'); img.src = g[i].src;
        $$('button', thumbs).forEach(function (t) { t.classList.toggle('is-active', t === b); });
        count.textContent = (i + 1) + ' / ' + g.length;
      };
      $('[data-m-type]', modal).textContent = 'Nor-Tech · ' + (m.typeLabel || '');
      $('[data-m-title]', modal).textContent = m.name;
      $('[data-m-tagline]', modal).textContent = m.tagline || '';
      $('[data-m-desc]', modal).textContent = m.blurb || '';
      $('[data-m-specs]', modal).innerHTML = (m.specs || []).map(function (r) {
        return '<tr><th>' + esc(r[0]) + '</th><td>' + esc(r[1]) + '</td></tr>';
      }).join('');
      var link = $('[data-m-link]', modal);
      if (m.link) { link.href = m.link; link.hidden = false; } else { link.hidden = true; }
      $('[data-m-quote]', modal).dataset.model = 'Nor-Tech ' + m.name;
      modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      $('.modal-close', modal).focus();
    }
    function closeModal() {
      if (!modal.classList.contains('is-open')) return;
      modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }

    root.addEventListener('click', function (e) {
      var o = e.target.closest('[data-open]'); if (o) openModal(o.dataset.open);
    });
    slider.addEventListener('keydown', function (e) {
      var o = e.target.closest('[data-open]');
      if (o && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); openModal(o.dataset.open); }
    });
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) closeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    $('[data-m-quote]', modal).addEventListener('click', function (e) {
      var v = e.currentTarget.dataset.model; closeModal();
      prefill('model', v);
    });

    syncUI();
  }

  /* ---------- inventory tabs ---------- */
  function initInventory(root) {
    var grid = $('[data-inv-grid]', root);
    if (!grid || grid.__nt) return; grid.__nt = true;
    var empty = $('[data-inv-empty]', root), emptyTitle = $('[data-inv-empty-title]', root);
    var cards = function () { return $$('.inv-card:not(.inv-cta)', grid); };

    function apply(filter, label) {
      var shown = 0;
      cards().forEach(function (c) {
        var tags = (c.dataset.tags || '').split(' ');
        var on = filter === 'all' || tags.indexOf(filter) > -1;
        c.hidden = !on; if (on) shown++;
      });
      if (empty) {
        empty.hidden = shown > 0;
        if (emptyTitle) emptyTitle.textContent = 'No ' + (filter === 'all' ? '' : label + ' ') + 'Nor-Techs listed right now';
      }
    }
    $$('[data-inv]', root).forEach(function (chip) {
      chip.addEventListener('click', function () {
        $$('[data-inv]', root).forEach(function (c) { c.setAttribute('aria-pressed', c === chip); });
        apply(chip.dataset.inv, chip.dataset.label || chip.textContent.trim().toLowerCase());
      });
    });
    grid.addEventListener('click', function (e) {
      var c = e.target.closest('[data-interest]');
      if (c && c.dataset.interest) prefill('interest', c.dataset.interest);
    });
    apply('all', '');
  }

  /* ---------- quote form ---------- */
  var slug = function (v) {
    return String(v || '').toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  };
  function wireCustomerCapture(root) {
    var form = $('[data-quote-form]', root), cust = $('[data-customer-form]', root);
    var optin = form && $('[data-q-optin]', form);
    if (!form || !cust || !optin || form.__ntCust) return; form.__ntCust = true;

    form.addEventListener('submit', function (e) {
      if (form.__ntSending) return;            /* second pass: let it submit normally */
      if (!optin.checked) return;              /* no opt-in: plain quote email only */
      e.preventDefault();
      form.__ntSending = true;
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.dataset.label = btn.innerHTML; btn.textContent = 'Sending…'; }

      var val = function (sel) { var el = form.querySelector(sel); return el ? el.value.trim() : ''; };
      var name = val('[name="contact[name]"]').split(/\s+/);
      $('[data-c-email]', cust).value = val('[name="contact[email]"]');
      $('[data-c-first]', cust).value = name.shift() || '';
      $('[data-c-last]', cust).value = name.join(' ');
      var tagsEl = $('[data-c-tags]', cust);
      var tags = (tagsEl.dataset.base || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
      var model = val('[data-q-model]'), state = val('[name="contact[Where you boat]"]'), interest = val('[data-q-interest]');
      if (model) tags.push('model-' + slug(model.replace(/^nor-?tech\s*/i, '')));
      if (state) tags.push('boats-' + slug(state));
      if (interest) tags.push('interest-' + slug(interest));
      tagsEl.value = tags.join(', ');

      /* create the customer in the background, never longer than 5s, then send the quote */
      var done = false;
      var finish = function () { if (done) return; done = true; HTMLFormElement.prototype.submit.call(form); };
      setTimeout(finish, 5000);
      try {
        fetch(cust.getAttribute('action') || '/contact', {
          method: 'POST', body: new FormData(cust), credentials: 'same-origin', redirect: 'follow'
        }).then(finish, finish);
      } catch (err) { finish(); }
    });
  }

  function initQuote(root) {
    wireCustomerCapture(root);
    var thanks = $('[data-q-thanks]', root);
    if (thanks && !thanks.__nt) {
      thanks.__nt = true;
      setTimeout(function () { root.scrollIntoView({ block: 'start' }); thanks.focus({ preventScroll: true }); }, 50);
    }
  }

  var INIT = { strip: initStrip, models: initModels, inventory: initInventory, quote: initQuote };
  function initAll(scope) {
    $$('[data-nt]', scope).forEach(function (el) { var fn = INIT[el.dataset.nt]; if (fn) fn(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    $$('[data-nt="models"]', e.target).forEach(function (r) {
      if (r.__ntModalHost) r.__ntModalHost.remove();
    });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target.closest && e.target.closest('.model-card');
    var slider = card && card.parentElement;
    if (card && slider) slider.scrollTo({ left: card.offsetLeft - slider.offsetLeft, behavior: 'smooth' });
    var strip = e.target.closest && e.target.closest('[data-strip-track]');
    if (strip) strip.scrollTo({ left: e.target.offsetLeft - strip.offsetLeft, behavior: 'smooth' });
  });
})();
